module.exports = require("../../../../lib").stronachgroup.first.external;
